// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"bd0cb901","132":"defbb03c","140":"bab4a075","167":"3480e023","223":"0530740a","236":"ad28ed88","364":"f3a7b6e2","405":"379df0d4","453":"a011262f","709":"fa86e952","811":"5905f403","957":"4eb0d6d6"}[chunkId] + ".chunk.js";
};